import { z } from 'zod';

/**
 * HAT-1109: זוד מייצר את הודעות ברירת המחדל שלו באנגלית.
 *
 * הסכימות שלנו מגדירות הודעה עברית לרוב השדות, אבל בדיקות הטיפוס והטווח
 * הבסיסיות (z.number(), .min()/.max(), z.union, z.enum) רצות *לפני* ה-superRefine
 * ועוצרות אותו - כך שכשל בהן דילג על ההודעה המנוסחת והציג טקסט אנגלי גולמי
 * למשתמש. הלוקאל העברי של זוד הוא רשת הביטחון: הודעה מפורשת בסכימה תמיד גוברת,
 * וכל מה שנופל דרכה מגיע בעברית - גם בטפסים שייכתבו בעתיד.
 *
 * צריך לרוץ פעם אחת בטעינת האפליקציה, לפני כל parse. main.tsx מייבא את הקובץ,
 * ומבחני יחידה על סכימות מייבאים אותו בעצמם.
 */
z.config(z.locales.he());
